import {Component} from '@angular/core';
import {BaseSupportModalComponent} from "./base_support.component";

@Component({
	templateUrl: './ban_sites_by_list.component.html'
})
export class BanSitesByListModalComponent extends BaseSupportModalComponent {
	title: string = 'Ban sites by list';
	domains: string = '';
	alertMessage: string = '';

	async ok() {
		this.alertMessage = '';
		
		if(this.domains.length < 4) {
			this.alertMessage = 'Message is empty!';
			
			return;	
		} 
		
		let domains = this.domains.split('\n')
			.map(function (r) {
				return r.trim();
			})
			.filter(function (r) {
				return r;
			});

		let r = new RegExp('^(http\:\/\/|https\:\/\/)?([a-z0-9][a-z0-9\-]*\.)+[a-z0-9][a-z0-9\-\/]*$', 'i');
		let isInvalidList = domains.some(site => {
			if(site.match(r) == null) {
				//this.alertMessage = `"${site}" is invalid site url`;
				return true;
			}
			return false;
		});

		if (!isInvalidList && confirm(`Вы уверены, что хотите забаннить эти сайты?`)) {
			await this.supportService.banSitesByList(domains, this.domains, this.spreader.base.comment).toPromise();
			
			this.execute();
		}
	}
}
